import script from "./MainHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainHeader.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/style/mainpage.css?vue&type=style&index=0&id=7b2e4b4c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b2e4b4c"]])

export default __exports__